import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {ActualURLPaths, FeaturesPaths} from "../models/routes-constants";

@Injectable({
  providedIn: 'root'
})
export class RegistrationRedirectGuard  {
    constructor(private router: Router) {
        console.log("RegistrationRedirectGuard")
    }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const queryParams = route.queryParams;
      if (queryParams && queryParams.inviteId) {
          this.router.navigate([ActualURLPaths.REGISTRATION], { queryParams });
          return false; // Return false to cancel the current navigation
      }
      return true; // No need to redirect
  }
  
}
